import React, { MouseEvent } from 'react';
import SvgIcon from 'src/react_components/svg-icon';

type Props = {
  disabled?: boolean;
  label: string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
  className?: string;
  loadingLabel?: string;
};

const LoadingButton: React.FC<Props> = (props) => {
  const {
    disabled, label, onClick, loading, className, loadingLabel
  } = props;

  const handleOnClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick(event);
  };

  const buttonContent = loading ? <SvgIcon icon="spinner" className="icon-spin" /> : label;

  return (
    <button
      disabled={disabled}
      className={className}
      onClick={handleOnClick}
      type="button"
    >
      {loading && loadingLabel}
      {buttonContent}
    </button>
  );
};

export default LoadingButton;
